import { BRAND_HAS_REWIND_OPE } from 'common/configuration/constants';

// add here the IDs of accounts for which rewind is pre-activated to test the functionality
const TEST_ACCOUNTS: string[] = [];

export const displayRewind = (userId?: string | number) =>
  BRAND_HAS_REWIND_OPE || TEST_ACCOUNTS.includes(`${userId}`);
